// extracted by mini-css-extract-plugin
export default {"padit":"cryptex_padit__jVqgZ","colorit":"cryptex_colorit__76oSt","borderitim":"cryptex_borderitim__XCsGf","cont":"cryptex_cont__jnsS5"};